/** Tab identifiers used on entity profile pages (animal, member, etc.). */
export const ENTITY_TAB = {
  PROFILE: 'profile',
  EBVS: 'ebvs',
  PEDIGREE: 'pedigree',
  TRANSFERS: 'transfers',
  NOTES: 'notes',
  PROGENY: 'progeny',
  SALES: 'sales',
  MEDIA: 'media',
  BILLING_EVENTS: 'billingEvents',
  GALLERY: 'gallery',
} as const;
